import { render } from "./InvoiceFollowups.vue?vue&type=template&id=211fea6a&scoped=true"
import script from "./InvoiceFollowups.vue?vue&type=script&lang=js"
export * from "./InvoiceFollowups.vue?vue&type=script&lang=js"

import "./InvoiceFollowups.vue?vue&type=style&index=0&id=211fea6a&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211fea6a"]])

export default __exports__